import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  info: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "24px",
    color: "#667085",
    marginLeft: "10px"
  },
  icon: {
    fontSize: "18px"
  },
  iconButton: {
    padding: "5px"
  },
  itemCenter: {
    display: "flex", 
    alignItems: "center" 
  }
}));

export default styles;
